import { render, staticRenderFns } from "./v20a7000pc.vue?vue&type=template&id=0998783a&scoped=true&"
import script from "./v20a7000pc.vue?vue&type=script&lang=js&"
export * from "./v20a7000pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0998783a",
  null
  
)

export default component.exports